import styled from 'styled-components'

export const StyledDiv = styled.div`
  border: none;
  clip: rect(0 0 0 0);
  height: 1px;
  width: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  position: absolute;
`
